import React, { Component } from "react";
import i18n from "i18n-react";

import renderHTML from "react-render-html";
import PropTypes from "prop-types";

import { AddFavorite, Diploma, StorageHandler } from "C4";
import { storageKeys } from "settings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SpotifyPlayer = (props) => {
  const { links, width } = props;
  const parsedElements = [];

  links.forEach((link, i) => {
    const key = `${link}_${i}`;
    if (link.url.length > 0 && link.url.includes("spotify")) {
      parsedElements.push(
        <iframe
          key={key}
          title={link.url}
          src={link.url}
          height="500px"
          width={width}
        />
      );
    }
  });

  return parsedElements;
};

export default class TrainingText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "",
      firstName: "",
      lastName: "",
      appName: "",
      clientName: "",
      diploma: false,
      email: "",
    };
  }

  componentDidMount() {
    const { appId, pageType, upID } = this.props;
    let { text } = this.props;
    this.getAppInfo();
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = "";
      ({ email } = userObj);
      if (pageType !== "Final-Page") {
        const anaUri = `https://crm.travpromobile.com/api/uri?email=${email}&app_id=${appId}&url=`;
        text = text.replace('href="', `href="${anaUri}`);
        text = text.replace(
          /href="/g,
          (
            (i) => (m) =>
              !i++ ? m : `href="${anaUri}`
          )(0)
        );
        text = text.split("<a").join('<a target="_blank"');
      }
      this.setState({ text });

      // const weblinks = text.getElementsByTagName('a');
      // for (let i = 0, len = weblinks.length; i < len; i++) {
      //   weblinks[i].target = '_blank';
      // }
    });

    this.props.contentComplete();
  }

  async getAppInfo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        appName: appInfo.appName,
        clientName: appInfo.clientName,
      });
    }

    const user = await StorageHandler.load(storageKeys.user);
    if (user) {
      this.setState({
        firstName: user.first_name,
        lastName: user.last_name,
        email: user.email,
      });
    }
  }

  render() {
    const {
      appId,
      buttons,
      links,
      pageID,
      pageType,
      subtitle,
      title,
      type,
      upID,
      hideTitle,
    } = this.props;

    const { text, diploma, firstName, lastName, appName, clientName, email } =
      this.state;

    return (
      <div
        className={`text__container ${
          pageType === "Final-Page" ? "wideFinalPage" : undefined
        }`}
        key={upID}
      >
        {/* <div className="text__container" key={upID}> */}
        {buttons}
        {(pageType === "Final-Page" || pageType === "Introduction") && (
          <div className="image" />
        )}
        {!hideTitle && (
          <h3
            className={`pageTitle ${
              pageType === "Final-Page" && "finalPageTitle"
            }`}
          >
            {title}
          </h3>
        )}
        <h4>{subtitle}</h4>
        {type === "Spotify" && <SpotifyPlayer links={links} width="100%" />}
        <div className="bodyContent">
          {renderHTML(
            text
              .replace(/&lt;/g, "<")
              .replace(/&gt;/g, ">")
              .replace(/allowTransparency="[a-zA-Z0-9:;.s()\-,]*"/gi, "")
              .replace(/allowfullscreen/gi, 'allowFullScreen="allowFullScreen"')
          )}
        </div>
        {pageType === "Final-Page" && (
          <div className="trophy">
            <button
              className="trophy__button"
              onClick={() => this.setState({ diploma: true })}
            >
              <FontAwesomeIcon icon={["fas", "trophy"]} />
              <span>{i18n.translate("general.viewBadge")}</span>
            </button>
          </div>
        )}

        {diploma === true && (
          <Diploma
            trigger={diploma}
            appId={+appId}
            firstName={firstName}
            lastName={lastName}
            onClose={() => this.setState({ diploma: false })}
            appName={encodeURI(appName)}
            clientName={encodeURI(clientName)}
            email={email}
          />
        )}

        {pageType !== "Final-Page" && (
          <AddFavorite
            appId={appId}
            viewType="p"
            upID={upID}
            pageID={pageID}
            bgEnabled
            centered
          />
        )}
      </div>
    );
  }
}

TrainingText.propTypes = {
  buttons: PropTypes.oneOfType([PropTypes.object, PropTypes.element]),
  appId: PropTypes.number.isRequired,
  contentComplete: PropTypes.func,
  hideTitle: PropTypes.bool,
  links: PropTypes.arrayOf(PropTypes.object),
  pageID: PropTypes.string,
  pageType: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  upID: PropTypes.string.isRequired,
};

TrainingText.defaultProps = {
  buttons: [],
  contentComplete: () => {},
  hideTitle: false,
  links: [],
  pageID: "",
  subtitle: "",
  text: "",
  title: "",
  type: "",
};
